// Downsizes a loaded HTMLImageElement to a JPEG blob URL for preview-only use.
// The original File is kept intact for upload — this is purely a mobile-memory
// optimisation so we don't keep a 1920x1080 bitmap decoded in the DOM.
export async function createDownscaledPreviewUrl(
  image: HTMLImageElement,
  maxWidth = 1280,
  maxHeight = 720,
  quality = 0.85,
): Promise<string> {
  const canvas = document.createElement("canvas");
  const scale = Math.min(maxWidth / image.width, maxHeight / image.height, 1);
  canvas.width = Math.round(image.width * scale);
  canvas.height = Math.round(image.height * scale);
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Canvas 2D context unavailable");
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  return new Promise<string>((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Canvas toBlob returned null"));
          return;
        }
        resolve(URL.createObjectURL(blob));
      },
      "image/jpeg",
      quality,
    );
  });
}
